module.exports = __webpack_public_path__ + "static/media/36.07ec7fc1.jpg";